import RegistroService from 'src/modules/registro/registroService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/history';

const prefix = 'REGISTRO_VIEW';

const registroViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: registroViewActions.FIND_STARTED,
      });

      const record = await RegistroService.find(id);

      dispatch({
        type: registroViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: registroViewActions.FIND_ERROR,
      });

      getHistory().push('/registro');
    }
  },
};

export default registroViewActions;
